import { render, staticRenderFns } from "./yekunkontrolu.vue?vue&type=template&id=9bd4dfca&"
import script from "./yekunkontrolu.vue?vue&type=script&lang=js&"
export * from "./yekunkontrolu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports